//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useMemo } from 'react';

import { router } from '@/routes';
import { type AgentTransport, createInProcessTransport } from './transport';
import { useAgentBridge } from './usePageSnapshot';

// The panel renders beside the router, not under it, so the location comes
// from the router singleton the error handler already navigates through.
export function useInProcessTransport(): AgentTransport {
  const bridge = useAgentBridge();
  return useMemo(() => createInProcessTransport({
    bridge,
    pathname: () => router.state.location.pathname,
    navigate: (path) => router.navigate(path)
  }), [bridge]);
}
